import React, { useState } from 'react';
import { CircularProgress, TypographyVariant } from '@mui/material';
import Sync from '@mui/icons-material/Sync';
import { SignableProviders } from '../../enums/SignableProvider';
import { SignableSchema } from '../../definitions/schemas';
import Link from '../Link';
import SignablesInterface from '../../graphql/Signables/SignablesInterface';
import SnackbarStore from '../../stores/observables/SnackbarStore';

interface Props {
  onSynced?: (signable: SignableSchema) => void;
  signable: SignableSchema;
  variant?: TypographyVariant;
}

const SignableSync: React.FC<Props> = (props: Props): JSX.Element => {
  const { onSynced, signable, variant = 'caption' } = props;

  const [syncing, setSyncing] = useState(false);

  const onSync = async () => {
    try {
      setSyncing(true);

      const response = await new SignablesInterface().refresh({
        id: signable.id,
      });

      let object = 'Signable document';
      if (signable.provider === SignableProviders.DocuSign) {
        object = 'DocuSign envelope';
      }

      SnackbarStore.show(`${object} status synced`);

      if (onSynced) {
        onSynced(response.refreshSignable.signable);
      }
    } catch (e) {
      SnackbarStore.show(`${e}`);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Link
      beforeIcon={
        syncing ? (
          <CircularProgress color="secondary" size={16} />
        ) : (
          <Sync color="inherit" fontSize="small" />
        )
      }
      onClick={onSync}
      text="Sync"
      variant={variant}
    />
  );
};

export default SignableSync;
